import { useStaticMutation } from '../../../helpers/useStaticData';

export const useCreateUserMutation = () => useStaticMutation();

export const useUpdateUserMutation = () => useStaticMutation();

export const useChangePasswordMutation = () => useStaticMutation();

export const useRememberPasswordAPIMutation = () => useStaticMutation();
